import "./App.css";
import { Link, Outlet } from "react-router-dom";

function App() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-md">
      {/* <h1 className="text-3xl font-bold text-center mb-6"> */}
      <Link to="/">
        <img
          src={process.env.PUBLIC_URL + "/logo.png"}
          className="w-1/4 mx-auto opacity-80 hover:opacity-70"
          alt="Link, Laugh, Love: with apologies to Robert Indiana"
        />
        <span className="invisible">Link, Laugh, Love</span>
      </Link>
      {/* </h1> */}
      <Outlet />
    </div>
  );
}

export default App;
